import React from 'react';
import { IconType } from '@ui/Icon';

export const REPLACEMENT_TABS = ['oxford', 'smart suggestions'] as const;
export type ReplacementTab = (typeof REPLACEMENT_TABS)[number];
export const REPLACEMENT_TAB_ICONS: Map<ReplacementTab, IconType> = new Map([
  ['smart suggestions', IconType.stars03],
]);

type Context = {
  tab: ReplacementTab;
  setTab: (tab: ReplacementTab) => void;
};

export const ReplacementTabContext = React.createContext<Context | undefined>(
  undefined
);
ReplacementTabContext.displayName = 'ReplacementTab';

export function useReplacementTab() {
  const context = React.useContext(ReplacementTabContext);

  if (context === undefined) {
    throw new Error(
      `${ReplacementTabContext.displayName} must be used within an <${ReplacementTabContext.displayName}Provider />`
    );
  }

  return context;
}

export default function ReplacementTabProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [tab, setTab] = React.useState<ReplacementTab>('oxford');
  const context = React.useMemo<Context>(
    () => ({
      tab,
      setTab,
    }),
    [tab]
  );
  return (
    <ReplacementTabContext.Provider value={context}>
      {children}
    </ReplacementTabContext.Provider>
  );
}
